module.exports = __webpack_public_path__ + "static/media/popup-super-box.b49f4188.png";